export default "__VITE_ASSET__u4ScsT1q__"